

























import { Component, Mixins, Prop } from 'vue-property-decorator'
import SalesReportMixin from '@/views/Reports/Report/SalesReport/SalesReportMixin'

@Component
export default class TurnoverPercentagePerBranchCurrentYearInformation extends Mixins(SalesReportMixin) {
    @Prop({ required: true }) type!: string
    @Prop() additionalType!: string
}
